module.exports = __webpack_public_path__ + "img/56884a9.png";